export default "__VITE_ASSET__BqaPqWYl__"